// @flow
import PropTypes from "prop-types";
import React, {useContext} from "react";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";

const SampleFilter = ({sampleType, includeDeleted, shortWidth, showIncludeDeleted, onFilterChanged, onIncludeDeletedChanged}) => {
    
    const [globalState] = useContext(StoreContext);

    function handleCBClicked(e) {
        e.stopPropagation(e);
    }
    
    return (
        <div className="">
            <select id="sampleTypeSelect" className={"li-form-field "+(shortWidth?"no-width":"")+" li-border-dark mr-3 "} name="sample-type-select" aria-label="Sample Type"
                    value={sampleType} onChange={(e)=>onFilterChanged(e)}>
                <option value="">all</option>
                {globalState.sampleTypes.items?.map( (item,index) => <option key={index} value={item.id}>{item.name}</option>)}
            </select>
            {showIncludeDeleted &&
                <>
                    <input id="includeDeletedIdCB" type="checkbox" className=" medium align-self-center" name="include-deleted-cb" aria-label="Checkbox"
                               checked={includeDeleted===true} 
                               onChange={(e)=>onIncludeDeletedChanged(e)} 
                               onClick={(e)=>handleCBClicked(e)}/>
                    <label className="li-form-label medium ml-2" htmlFor="includeDeletedIdCB">include deleted</label>
                </>
            }
        </div>
    );
}

SampleFilter.propTypes = {
    sampleType: PropTypes.string.isRequired,
    onFilterChanged: PropTypes.func.isRequired,
    includeDeleted: PropTypes.bool,
    onIncludeDeletedChanged: PropTypes.func,
    showIncludeDeleted: PropTypes.bool,
    shortWidth: PropTypes.bool
};

export default SampleFilter;